import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoImg from 'eco-design/base/eco-img';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper/types';
import css from './index.module.scss';

interface Props {}
interface ItfItem {
    tab: string;
    img: [string, string];
    text: string;
}

const L: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.L');
    const { isPC } = useDeviceDetect();
    const [swiper, setSwiper] = useState<SwiperType | null>(null);
    const [active, setActive] = useState(0);

    const { locale = 'us' } = getLocal();

    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    const items: ItfItem[] = [
        {
            tab: t('1_tab'),
            text: t('1_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762764789081-ecar3o-compressed-Frame%201612707952.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762764822832-ip89mi-compressed-Frame%201000009236.jpg',
            ],
        },
        {
            tab: t('2_tab'),
            text: t('2_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762515099379-xdxwot-compressed-Frame%201612707953.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762515108513-6btsni-compressed-Frame%201612707942.jpg',
            ],
        },
        {
            tab: t('3_tab'),
            text: t('3_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762515124487-ymltp7-compressed-Frame%201612707949.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762515132307-fr6tbt-compressed-Frame%201612707947.jpg',
            ],
        },
        {
            tab: t('4_tab'),
            text: t('4_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762515145049-moaszp-compressed-Frame%201612707976.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762515154488-1uv704-compressed-Frame%201612707975.jpg',
            ],
        },
    ];

    const objImgs = {
        eu: [
            'https://websiteoss.ecoflow.com/figma-uploads/1762515124487-ymltp7-compressed-Frame%201612707949.jpg',
            'https://websiteoss.ecoflow.com/figma-uploads/1762515132307-fr6tbt-compressed-Frame%201612707947.jpg',
        ],
        de: [
            'https://websiteoss.ecoflow.com/figma-uploads/1772077109757-3p50k5-compressed-Frame%201612708009.jpg',
            'https://websiteoss.ecoflow.com/figma-uploads/1772077130688-q67zzg-compressed-Frame%201612708030.jpg',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/figma-uploads/1772077178884-rut9c8-compressed-Frame%201612708011.jpg',
            'https://websiteoss.ecoflow.com/figma-uploads/1772077205636-xv6ge3-compressed-Frame%201612708031.jpg',
        ],
        it: [
            'https://websiteoss.ecoflow.com/figma-uploads/1772077232452-qrafkx-compressed-Frame%201612708013.jpg',
            'https://websiteoss.ecoflow.com/figma-uploads/1772077245947-7a8ob7-compressed-Frame%201612708032.jpg',
        ],
        es: [
            'https://websiteoss.ecoflow.com/figma-uploads/1772077272990-brbe6h-compressed-Frame%201612708015.jpg',
            'https://websiteoss.ecoflow.com/figma-uploads/1772077285438-k61h5i-compressed-Frame%201612708033.jpg',
        ],
    };

    const itemsEU: ItfItem[] = [
        {
            tab: t('1_tab'),
            text: t('1_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762764789081-ecar3o-compressed-Frame%201612707952.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762764822832-ip89mi-compressed-Frame%201000009236.jpg',
            ],
        },
        {
            tab: t('2_tab'),
            text: t('2_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762515099379-xdxwot-compressed-Frame%201612707953.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762515108513-6btsni-compressed-Frame%201612707942.jpg',
            ],
        },
        {
            tab: t('3_tab'),
            text: t('3_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1772089433759-x4q92w-compressed-Image.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1772089482506-vumxfo-compressed-Frame%201612707946.jpg',
            ],
        },
        {
            tab: t('4_tab'),
            text: t('4_text'),
            img: objImgs[locale] || objImgs['eu'],
        },
        {
            tab: t('5_tab'),
            text: t('5_text'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1762515145049-moaszp-compressed-Frame%201612707976.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1762515154488-1uv704-compressed-Frame%201612707975.jpg',
            ],
        },
    ];

    const list = IS_EU_SITE ? itemsEU : items;

    const handleSlideChange = (swiperIns: SwiperType) => {
        setActive(swiperIns.realIndex);
        tabFix(swiperIns.realIndex);
    };

    const tabFix = (index: number) => {
        const targetTabItem = document.querySelectorAll('.rapid-mag-L .tab')[index];
        const tabsEle = document.querySelector('.rapid-mag-L .tabs');

        if (!targetTabItem || !tabsEle) return;
        const targetTabItemRect = targetTabItem.getBoundingClientRect();

        const tabsEleRect = tabsEle.getBoundingClientRect();

        tabsEle.scrollBy({
            left: targetTabItemRect.left - tabsEleRect.left - tabsEleRect.width / 2 + targetTabItemRect.width / 2,
            behavior: 'smooth',
        });
    };

    const handleChangeTab = (index: number) => {
        if (index === active) return;
        swiper?.slideToLoop(index);
        tabFix(index);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: list[index].tab,
            __btn_id1: `rapid-mag-L .tab${index}`,
            __btn_id2: list[index].tab,
            __btn_type: 'text',
        });
    };

    return (
        <section
            id="rapid-mag-L"
            className={`rapid-mag-L ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-L'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
            </div>
            <Swiper
                className="items"
                slidesPerView={1}
                spaceBetween={isPC ? 24 : 12}
                centeredSlides={true}
                loop={true}
                onSwiper={(swipwerIns: SwiperType) => setSwiper(swipwerIns)}
                onSlideChange={handleSlideChange}
            >
                {list.map((item: ItfItem) => (
                    <SwiperSlide className="item" key={item.tab}>
                        <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <ul className="tabs">
                {list.map((item: ItfItem, index: number) => (
                    <li
                        className={`${active === index ? 'active ' : ''}tab tab${index} GtmModuleData-btn-text`}
                        key={item.tab}
                        onClick={() => handleChangeTab(index)}
                    >
                        {item.tab}
                    </li>
                ))}
            </ul>
            <p className="text">{list[active]?.text}</p>
        </section>
    );
};
export default L;
